import { CompanyTagsContext } from './CompanyTagsContext';
import CompanyTagsProvider from './CompanyTagsProvider';
import { useCompanyTagsContext } from './useCompanyTagsContext';

export { CompanyTagsContext, useCompanyTagsContext };

export default CompanyTagsProvider;
